import { render, staticRenderFns } from "./menuComponent.vue?vue&type=template&id=34bea53a&scoped=true&"
import script from "./menuComponent.vue?vue&type=script&lang=ts&"
export * from "./menuComponent.vue?vue&type=script&lang=ts&"
import style0 from "./menuComponent.vue?vue&type=style&index=0&id=34bea53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bea53a",
  null
  
)

export default component.exports